// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/javascripts/libraries_and_infrequently_changed.js
// MAGIC_DESPROCKET_END
//= require core_pre_webpack/routes
//= require core_pre_webpack/utils/more_text_helpers
//= require_tree ./utils
//= require_tree ./metrics
// MAGIC_DESPROCKET_START
require('javascripts/core_pre_webpack/routes.js')
require('sprocket-compat?this!javascripts/core_pre_webpack/utils/more_text_helpers.coffee')
require('sprocket-compat?this!javascripts/core_pre_webpack/utils/general_helpers.js')
require('sprocket-compat?this!javascripts/core_pre_webpack/utils/global_incrementor.coffee')
require('javascripts/core_pre_webpack/utils/i18n_helpers.js')
require('javascripts/core_pre_webpack/utils/more_general_helpers.js')
require('javascripts/core_pre_webpack/utils/parse_url.js')
require('javascripts/core_pre_webpack/utils/text_helpers.js')
require('sprocket-compat?this!javascripts/core_pre_webpack/metrics/server_notification.js')
// MAGIC_DESPROCKET_END
